import { Controller, useFormContext } from 'react-hook-form';
import { Radio, RadioProps } from 'antd';

interface FormRadioProps extends RadioProps {
  name: string;
  children: React.ReactNode;
}

export const FormRadio = ({ name, children, ...props }: FormRadioProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <Radio.Group onChange={onChange} value={value} {...props}>
          {children}
        </Radio.Group>
      )}
    />
  );
};
